module.exports = __webpack_public_path__ + "static/media/button.a9ec3cec.png";